import csTools from 'cornerstone-tools';
const BaseAnnotationTool = csTools.importInternal('base/BaseAnnotationTool');
// State
const getToolState = csTools.getToolState;

// Drawing
const getNewContext = csTools.importInternal('drawing/getNewContext');
const draw = csTools.importInternal('drawing/draw');
const drawLine = csTools.importInternal('drawing/drawLine');
const drawEllipse = cornerstoneTools.importInternal('drawing/drawEllipse');
const drawHandles = cornerstoneTools.importInternal('drawing/drawHandles');
const setShadow = csTools.importInternal('drawing/setShadow');

// import { getLogger } from '../../util/logger.js';
const getPixelSpacing = csTools.importInternal('util/getPixelSpacing');
const throttle = csTools.importInternal('util/throttle');
const getModule = cornerstoneTools.getModule

// const logger = getLogger('tools:annotation:LengthTool');

/**
 * @public
 * @class ExternalAnnotationsTool
 * @memberof Tools.Annotation
 * @classdesc Tool for showing external tool data.
 * @extends Tools.Base.BaseAnnotationTool
 */
export default class ExternalAnnotationsTool extends BaseAnnotationTool {
  constructor(props = {}) {
    const defaultProps = {
      name: 'ExternalAnnotations',
      supportedInteractionTypes: ['Mouse', 'Touch'],
      svgCursor: null,
      configuration: {
        drawHandles: true,
        drawHandlesOnHover: false,
        hideHandlesIfMoving: false,
        renderDashed: false,
        digits: 2,
      },
    };

    super(props, defaultProps);

    this.throttledUpdateCachedStats = throttle(this.updateCachedStats, 110);
  }

  createNewMeasurement(eventData) {
    return;

    return {
      visible: true,
      active: true,
      color: undefined,
      invalidated: true,
      type: 'POLYLINE',
      handles: {
        start: {
          x,
          y,
          highlight: true,
          active: false,
        },
        end: {
          x,
          y,
          highlight: true,
          active: true,
        },
      },
    };
  }

  /**
   *
   *
   * @param {*} element
   * @param {*} data
   * @param {*} coords
   * @returns {Boolean}
   */
  pointNearTool(element, data, coords) {
    return false
  }

  updateCachedStats(image, element, data) {
    const { rowPixelSpacing, colPixelSpacing } = getPixelSpacing(image);

    // Set rowPixelSpacing and columnPixelSpacing to 1 if they are undefined (or zero)
    const dx =
      (data.handles.end.x - data.handles.start.x) * (colPixelSpacing || 1);
    const dy =
      (data.handles.end.y - data.handles.start.y) * (rowPixelSpacing || 1);

    // Calculate the length, and create the text variable with the millimeters or pixels suffix
    const length = Math.sqrt(dx * dx + dy * dy);

    // Store the length inside the tool for outside access
    data.length = length;
    data.invalidated = false;
  }

  renderToolData(evt) {
    const eventData = evt.detail;
    const toolData = getToolState(evt.currentTarget, this.name);

    if (!toolData) {
      return;
    }

    // We have tool data for this element - iterate over each one and draw it
    const context = getNewContext(eventData.canvasContext.canvas);
    const { element } = eventData;

    for (let i = 0; i < toolData.data.length; i++) {
      const data = toolData.data[i];

      if (data.visible === false) {
        continue;
      }

      draw(context, context => {
        // Configurable shadow
        setShadow(context, this.configuration);

        const color = '#88ff00';

        const lineOptions = { color };

        if (data.type == 'POLYLINE') {
          drawLine(
            context,
            element,
            data.handles.start,
            data.handles.end,
            lineOptions
          );
        }

        if (data.type == 'ELLIPSE') {
          drawEllipse(
            context,
            element,
            data.handles.start,
            data.handles.end,
            lineOptions,
            'pixel',
            0
          );
        }

        if (data.type == 'POINT') {
          drawHandles(context, eventData, data.handles, lineOptions);
        }

      });
    }
  }
}
